<template>
  <section class="topPicksListing defaultSectionMargins">
    <div v-if="data" class="container">
      <h2 v-text="data.title" />
      <Tabs :tabs="tabs" class="topPicksListing__Tabs" :class="{ isLoading: !isFlickityVisible }" v-model="activeTab">
        <template v-for="tabItem in tabs" v-slot:[tabItem.value]>
          <ClientOnly>
            <FlickitySlider :with-progress="showProgressAndButtons(tabItem)" :options="{ ...flickityOptions, prevNextButtons: showProgressAndButtons(tabItem) }" v-if="isFlickityVisible">
              <TopPicksItem v-for="item in tabItem.items" :data="item" />
            </FlickitySlider>
          </ClientOnly>
        </template>
      </Tabs>
    </div>
  </section>
</template>

<script setup>
  const props = defineProps({
    data: {},
  });

  const accommodationsData = useState('accommodationsData');
  const dataLayerList = useState('dataLayerList');

  const flickityOptions = {
    pageDots: false,
    contain: true,
  }

  const isFlickityVisible = ref(true)
  const tabs = computed(() => {
    return props.data.items.map((item, index) => {
      return {
        title: item.title,
        value: `item${index}`,
        items: item.items
      }
    })
  });
  const activeTab = ref(tabs.value[0].value || null);
  let allItems = [];
  let ecommerceItems = [];
  props.data.items.forEach(tab => {
    allItems.push(...tab.items);
  });
  ecommerceItems = allItems.map((item, index) => {
    let accommodation = accommodationsData.value[item.accommodation];
    if (!accommodation) return null;
    return {
      'item_id': accommodation.id,
      'item_name': accommodation.name,
      'item_category': accommodation.kind === 'CAMP' ? 'Campsites' : 'Hotels and resorts',
      'item_category2': accommodation.place?.name,
      'item_brand': accommodation.brand?.name,
      'item_list_name': props.data.title,
      'item_list_id': 'Homepage',
      'index': index + 1,
    }
  }).filter(item => item !== null);

  onMounted(() => {
    dataLayerList.value = ecommerceItems;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      'event': 'view_item_list',
      'ecommerce': {
        'items': ecommerceItems,
      },
    });
  });

  function showProgressAndButtons(item) {
    return window?.innerWidth <= 768 && item.items.length > 1 || window?.innerWidth > 768 && item.items.length > 2
  }

  watch(activeTab, () => {
    isFlickityVisible.value = false
    setTimeout(() => {
      isFlickityVisible.value = true
    }, 1)
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_topPicksListing.scss');
</style>